import Model from '../Model';

// Abstract Transcript model
// see sub-models for more specific examples
export default Model.extend({

});
